import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Doughnut } from "react-chartjs-2";
import { getAudienceAnalytics } from "api/AudienceApi";
import { getCompany } from "api/AccountsApi";
import Moment from "moment";
import ContactLoader from "views/ContantLoader";
import "../../assets/css/eventsReport.css"

export default class AllAudience extends React.Component {
  state = {
    arr: [],
    fromdate: "",
    todate: "",
    dontLoad: false,
    content: [],
    audiences: [],
    labels: ["Bounces", "Email Delivered"],
    companyName: "",
    datasets: [
      {
        label: "Rainfall",
        backgroundColor: ["#6BC7BC", "#5962AC"],
        hoverBackgroundColor: ["#6BC7BC", "#5962AC"],
        data: [5, 5],
      },
    ],
  };

  options = {
    cutoutPercentage: 75,
    weight: 0.2,
    legend: {
      display: true,
      position: "bottom",
      fontSize: 14,
      labels: {
        usePointStyle: true,
        fontSize: 12,
      },
    },
    tooltips: {
      bodySpacing: 0,
      mode: "nearest",
      intersect: 0,
      position: "nearest",
      xPadding: 10,
      yPadding: 10,
      caretPadding: 30,
      cornerRadius: 15,
    },
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ dontLoad: true });
    }, 10000);
    getAudienceAnalytics()
      .then((data) => {
        const content = data;

        this.setState({ content });
        const fromdate = Moment(data.period.fromDate).format("MMM D,YYYY");
        this.setState({ fromdate });
        const todate = Moment(data.period.toDate).format("MMM D,YYYY");
        this.setState({ todate });
        this.state.datasets[0].data = [data.totalBounce, data.totalDelivery];
        let audiences = content.topAudiences;
        this.setState({ audiences });
      })
      .catch((e) => { });

    getCompany()
      .then((data) => {
        this.setState({ companyName: data.name });
      })
      .catch((e) => { });
  }

  render() {
    return (
      <>
        <div>
          <div className="page_heading">
            <h2>Audience</h2>
            {/* <p>{this.state.companyName}</p> */}
          </div>
          <div style={{ padding: '18px 66px 55px 60px' }} className="account_list_outer all_audience">
            <div className="row" style={{ flexWrap: 'initial' }}>
              <div style={{ marginRight: '17px' }} className="eBox col-md-6">
                <div className="recent_growth d-flex flex-wrap align-items-center">
                  <div className="icon tag_icon">
                    <span className="icon-growth1"></span>
                  </div>
                  <div className="growth_text">
                    <p className="font4">Recent Growth</p>
                    <p className="font7">
                      New contacts added to this audience in the last 30 days.
                    </p>
                  </div>
                </div>
                <div className="chart_outer">
                  <div className="row">
                    <div className="col-lg-8 pr_01">
                      <Doughnut
                        data={this.state}
                        options={{
                          cutoutPercentage: 75,
                          weight: 0.2,
                          legend: {
                            display: true,
                            position: "bottom",
                            fontSize: 14,
                            labels: {
                              usePointStyle: true,
                              fontSize: 12,
                            },
                          },
                          tooltips: {
                            bodySpacing: 0,
                            mode: "nearest",
                            intersect: 0,
                            position: "nearest",
                            xPadding: 10,
                            yPadding: 10,
                            caretPadding: 30,
                            cornerRadius: 15,
                          },
                        }}
                      />
                    </div>
                    <div className="col-lg-4 pl-01">
                      <div className="email_open">
                        <span>
                          <i class="fa fa-envelope-open" aria-hidden="true"></i>
                        </span>
                        <span>Email Open</span>
                        <span>{this.state.content.totalOpen}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/*  */}
                <div className="campaign_accounts ">
                  <div className="campaign_accounts_wrapper">
                    <div className="full_campaigns d-flex new_campaign">
                      <div className="icon">
                        {" "}
                        <span className="now-ui-icons icon-campaign "></span>
                      </div>
                      <div className="text">
                        <h3>{this.state.content.totalCampaign} Campaigns</h3>
                        <p>
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                    </div>
                    {/* <div className="full_campaigns d-flex  new_account">
                      <div className="icon ">
                        {" "}
                        <span className="now-ui-icons icon-dashboard-icons-03 "></span>
                      </div>
                      <div className="text">
                        <h3>
                          {this.state.content.newPersonAdded} New Accounts
                        </h3>
                        <p>
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                    </div> */}
                    <div className="full_campaigns d-flex new_audience">
                      <div className="icon">
                        {" "}
                        <span className="now-ui-icons icon-dashboard-icons-02"></span>
                      </div>
                      <div className="text">
                        <h3>
                          {this.state.content.numberOfAudience} New Audience
                        </h3>
                        <p>
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/*  */}
              </div>
              <div className="eBox col-md-6">
                <div className="recent_growth d-flex flex-wrap align-items-center">
                  <div className="icon user_icon">
                    <span className="now-ui-icons icon-dashboard-icons-03"></span>
                  </div>
                  <div className="growth_text">
                    <p className="font4">Top Audiences</p>
                    <p className="font7">
                      Your Audiences with number of contacts
                    </p>
                  </div>
                </div>
                <div className="tags_outer">
                  <ul>
                    {this.state.audiences ? (
                      this.state.audiences.length > 0 ? (
                        this.state.audiences
                          .slice(0, 4)
                          .map((audience, index) => (
                            <li
                              key={index}
                              className="d-flex flex-wrap align-items-center"
                            >
                              <div className="tag_count">
                                <h4>{audience.count}</h4>
                              </div>
                              <p
                                style={{
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  width: "160px",
                                }}
                                className="font4"
                              >
                                {audience.name}
                              </p>
                              <a href="">
                                <span className="icon-send1"></span>
                              </a>
                            </li>
                          ))
                      ) : (
                        "No data available"
                      )
                    ) : (
                      <ContactLoader />
                    )}
                    <li className="more_tags d-flex justify-content-end align-items-start">
                      <a href="/admin/contact/audience/details" className="text_btn">
                        more audience{" "}
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
